import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

export interface XStep {
  readonly key: string;
  readonly label: string;
}

enum StepState {
  Completed = 'completed',
  Active = 'active',
  Pending = 'pending',
}

@Component({
  selector: 'x-stepper',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-stepper.component.html',
  styleUrl: './x-stepper.component.scss',
})
export class XStepperComponent {
  protected readonly StepState = StepState;

  steps = input.required<ReadonlyArray<XStep>>();
  activeStep = input.required<string>();
  linear = input(true);

  stepChanged = output<string>();

  protected readonly activeStepIndex = computed(() => {
    const index = this.steps().findIndex((s) => s.key === this.activeStep());
    return index >= 0 ? index : 0;
  });

  protected getStepState(index: number): StepState {
    const activeIndex = this.activeStepIndex();
    if (index < activeIndex) {
      return StepState.Completed;
    }
    if (index === activeIndex) {
      return StepState.Active;
    }
    return StepState.Pending;
  }

  protected isStepClickable(index: number): boolean {
    if (!this.linear()) {
      return true;
    }
    return this.getStepState(index) === StepState.Completed;
  }

  protected onStepClick(step: XStep, index: number): void {
    if (!this.isStepClickable(index)) {
      return;
    }
    this.stepChanged.emit(step.key);
  }

  protected isLastStep(index: number): boolean {
    return index === this.steps().length - 1;
  }
}
